import { GET_CREDIT_CARD_BY_PHONE_NUMBER, CLEAR_CREDIT_CARD } from '../actions';
export default function (state = {}, action) {
    switch (action.type) {
        case GET_CREDIT_CARD_BY_PHONE_NUMBER:
            if (action.payload.data) {
                return action.payload.data
            } else {
                return {}
            }
        case CLEAR_CREDIT_CARD:
            return action.payload
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/customer_credit_card_reducer.js